import template from './employee_employment_listing_report_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EmployeeEmploymentListingReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeeEmploymentListingReportHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeEmploymentListingReportHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeeEmploymentListingReportHelp',
	dialog_class: EmployeeEmploymentListingReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_employment_listing_report_help',
	provider: 'ps'
};
